import * as authMutation from '@/store/modules/auth/mutation-types'
import * as datapoolMutation from '@/store/modules/datapool/mutation-types'
import * as socketMutation from '@/store/modules/socket/mutation-types'
import * as missionMutation from '@/store/modules/mission/mutation-types'
import * as gliderMutation from '@/store/modules/glider/mutation-types'
import * as enseigneMutation from '@/store/modules/enseigne/mutation-types'
import * as umbClasseMutation from '@/store/modules/umbClasse/mutation-types'
import * as umbTypeMutation from '@/store/modules/umbType/mutation-types'
import * as userMutation from '@/store/modules/user/mutation-types'
import * as uniteMobileMutation from '@/store/modules/uniteMobile/mutation-types'
import * as mesureTypeMutation from '@/store/modules/mesureType/mutation-types'
import * as missionGlobalMutation from '@/store/modules/missionGlobal/mutation-types'
import * as missionVirtualMutation from '@/store/modules/missionVirtual/mutation-types'
import * as coverageIterationMutation from '@/store/modules/coverageIteration/mutation-types'
import * as mesureUniteMutation from '@/store/modules/mesureUnite/mutation-types'
import * as adminMissionMutation from '@/store/modules/adminMission/mutation-types'
import * as debugMutation from '@/store/modules/debug/mutation-types'
import * as layermapMutation from '@/store/modules/layermap/mutation-types'
import * as uiMutation from '@/store/modules/ui/mutation-types'
import * as fleetMutation from '@/store/modules/fleet/mutation-types'
import * as roleMutation from '@/store/modules/role/mutation-types'
import * as adminFleetMutation from '@/store/modules/adminFleet/mutation-types'
import * as missionPlanTemplateMutation from '@/store/modules/missionPlanTemplate/mutation-types'
import * as positionRemarquableMutation from '@/store/modules/positionRemarquable/mutation-types'
import * as mapLayerMutation from '@/store/modules/mapLayer/mutation-types'
//import * as mapLayerMutation from '@/store/modules/mapLayer/mutation-types'

export default {  
  ...authMutation,
  ...datapoolMutation,
  ...socketMutation,
  ...missionMutation,
  ...gliderMutation,
  ...enseigneMutation,
  ...umbClasseMutation,
  ...umbTypeMutation,
  ...userMutation,
  ...uniteMobileMutation,
  ...mesureTypeMutation,
  ...mesureUniteMutation,
  ...adminMissionMutation,
  ...debugMutation,
  ...layermapMutation,
  ...uiMutation,
  ...fleetMutation,
  ...roleMutation,
  ...adminFleetMutation,
  ...missionPlanTemplateMutation,
  ...positionRemarquableMutation,
  ...mapLayerMutation,
  ...missionGlobalMutation,
  ...missionVirtualMutation,
  ...coverageIterationMutation
}